//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import QrcodeVue from 'qrcode.vue'



import UMUM from "../../library/umum";
// import QrcodeVue from 'qrcode.vue'

export default {
    props: ["form", 'uraian'],
    components: {
        QrcodeVue
    },
    data() {
        return {
            UMUM : UMUM,
            value: 'https://tambosupa.desa.konaweselatankab.go.id/detilKegiatan?id=1l3ulfgqs',

        }
    },

}
